<div class="content">
  <p class="help-text">
    {{ "are-you-sure-you-want-to" | transloco }} {{ actionType }}
    {{ taxReturnAlias }} {{ "for" | transloco }} {{ taxReturn.firstName }}
    {{ taxReturn.lastName }}?
  </p>

  <form [formGroup]="form" class="ui form">
    <div class="field">
      <label>{{ "requested-by" | transloco }}</label>
      <mat-select
        class="selection form-control small"
        formControlName="source"
        #formatted
      >
        @for (option of sourceList; track option) {
        <mat-option [value]="option">
          {{ option.label }}
        </mat-option>
        }
      </mat-select>
    </div>
    <div class="field">
      <label>{{ "reason" | transloco }}</label>
      <textarea rows="2" formControlName="reason"></textarea>
    </div>

    @if (showChangeCount) {
    <div class="field field--inline">
      <label *transloco="let t">{{
        actionType === "amend" ? t("amendment-number") : t("revision-number")
      }}</label>
      <input
        type="number"
        formControlName="changeCount"
        class="form-control change-count"
        min="1"
      />
    </div>
    }
  </form>
</div>
<div class="actions">
  <a class="go-back cancel" (click)="cancel.emit()">{{
    "cancel" | transloco
  }}</a>
  <button
    class="ui primary button"
    (click)="submitReason()"
    [disabled]="form.invalid"
  >
    {{ actionType | titlecase }} {{ taxReturnAlias }}
  </button>
</div>
